import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from "rxjs";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {NotificationsService, ProjectService} from "@catcore/services";
import {isNullOrUndefined} from "util";
import {ProjectSpeakerPortService} from "@catmodels/project-speaker-setup/services/project-speaker-port.service";
import {ModalService} from "@catmodules/widgets/slide-in-modal/services/modal.service";
import {ModifyGgwProfileComponent} from "@catmodels/ggw-profiles/components/modify-ggw-profile/modify-ggw-profile.component";
import {ModifyInputChannelsComponent} from "@catmodels/project-speaker-setup/components/modify-input-channels/modify-input-channels.component";
import {GenericLinkedResource} from "@catcore/types/base";
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";

@Component({
  selector: 'catapp-input-assignment',
  templateUrl: './input-assignment.component.html',
  styleUrls: ['./input-assignment.component.scss']
})
export class InputAssignmentComponent implements OnInit, OnDestroy {

  private projectSubscription: Subscription;
  private speakerPortSubscription: Subscription;
  private project = null;

  speakerPorts: any = [];
  guiZones: any = [];

  constructor(private projectService: ProjectService,
              private projectSpeakerPortService: ProjectSpeakerPortService,
              private genericService: GenericResourceService,
              private notification: NotificationsService,
              private modalService: ModalService) {
  }

  ngOnInit() {
    // first get the current project
    this.projectSubscription = this.projectService.getCurrentProject()
      .subscribe((project) => {
        const isActiveProject = !isNullOrUndefined(project) && !isNullOrUndefined(project.id);
        if (isActiveProject) {
          this.dataTableInitialized = false;
          this.project = project;
          this.updateSpeakerPorts();
          this.guiZones = this.projectService.extractGuiZonesFrom(this.project)
            .filter((zone) => zone.type === 'zone');
        }
      });
  }

  ngOnDestroy() {
    this.projectSubscription.unsubscribe();
  }

  tableItems: any[] = [];
  dataTableInitialized = false;

  columns = {
    zone: {field: 'zone', header: 'Zone'},
    speaker: {field: 'speaker', header: 'Speaker'},
    port: {field: 'port', header: 'Speaker Input Port'},
    apaPort: {field: 'apaPort', header: 'APA Output Port'},
    volumeControlChannel: {field: 'volumeControlChannel', header: 'Volume Control Channel'},
    dacRange: {field: 'dacRange', header: 'DAC Range'},
    pgaGain: {field: 'pgaGain', header: 'PGA Gain'},
    channelMix: {field: 'channelMix', header: 'Input Channels'},
  };

  dataAvailable() {
    return !isNullOrUndefined(this.tableItems) && this.tableItems.length !== 0;
  }

  editButtonClick(rowData) {
    this.openModalForChannelEdit(rowData.speakerPort);
  }

  private updateSpeakerPorts() {
    if (this.speakerPortSubscription) {
      this.speakerPortSubscription.unsubscribe();
    }
    this.speakerPorts = [];
    this.speakerPortSubscription = this.projectService.getAllSpeakerPorts(this.project)
      .subscribe((speakerPorts) => {
        this.speakerPorts = speakerPorts;
        this.createDataTableItems(speakerPorts);
        this.dataTableInitialized = true;
      });
  }

  private updateSpeakerPort(speakerPort) {
    this.genericService.findServiceForResource(speakerPort._links.self.href)
      .loadAndGet()
      .subscribe((sp) => {
         const idx = this.speakerPorts.findIndex((e) => e.id === sp.id);
         if (idx >= 0) {
           this.speakerPorts.splice(idx, 1, sp);
           this.createDataTableItems(this.speakerPorts);
         }
      })
  }

  private openModalForChannelEdit(speakerPort) {
    const compRef = this.modalService.open(ModifyInputChannelsComponent);
    compRef.componentInstance.guiZones = this.guiZones;
    compRef.componentInstance.speakerPort = speakerPort;
    compRef.componentInstance.afterUpdate.subscribe((multiple) => this.updateSpeakerPort(speakerPort));
    return compRef;
  }

  private createDataTableItems(items: any[]) {
    this.tableItems = [];

    items.forEach((speakerPort) => {
      const data = {
        speakerPort: speakerPort,
        zone: speakerPort._links.gui_zone.label,
        speaker: speakerPort._links.unit.label,
        port: speakerPort.label,
        channelMix: this.getChannelMixLabel(speakerPort),
        volumeControlChannel: this.getChannelLabel(speakerPort.volume_control_channel),
        dacRange: speakerPort.dac_range,
        pgaGain: speakerPort.pga_gain,
        apaPort: speakerPort._links.hasOwnProperty('apa_output_port') ? speakerPort._links.apa_output_port.label : ''
      };
      this.tableItems = [...this.tableItems, data];
    });
  }

  private getChannelLabel(channel: string) {
    switch(channel) {
      case 'leftFront': return 'Left Front';
      case 'rightFront': return 'Right Front';
      case 'leftRear': return 'Left Rear';
      case 'rightRear': return 'Right Rear';
      case 'center': return 'Center';
      case 'other': return 'Other/Sub';
      default: return channel;
    }
  }

  private getChannelMixLabel(speakerPort) {
    if (!speakerPort._links.hasOwnProperty("input_signals")) {
      return "";
    }

    return speakerPort._links.input_signals.map((m) => m.label).join(', ');
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/project-speaker-setup/components/input-assignment/input-assignment.component.ts